/**
 * 健壮的下载工具函数
 * @param {string|Blob} source 下载源 (URL 或 Blob)
 * @param {string} [filename] 可选的文件名
 */
export function downloadFile(source, filename = '') {
    if (!source) return;

    let url;
    let isBlob = false;

    if (source instanceof Blob) {
        url = window.URL.createObjectURL(source);
        isBlob = true;
    } else {
        url = source;
    }

    const link = document.createElement('a');
    link.href = url;

    // 设置下载文件名 (同源或 Blob URL 生效)
    if (filename) {
        link.download = filename;
    } else {
        link.setAttribute('download', '');
    }

    // 为兼容 Firefox，必须添加到 body
    link.style.cssText = 'display:none; visibility:hidden;';
    document.body.appendChild(link);

    // 触发点击
    link.click();

    // 同步移除
    document.body.removeChild(link);

    // 如果是 Blob URL，延迟释放内存
    if (isBlob) {
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 1000 * 10);
    }
}

export default downloadFile;
